import Axios from 'axios'

class SchoolService {
  async fetch (state, zipcode) {
    try {
      const response = await Axios({
        url: '/teachers/fetchSchools',
        method: 'post',
        data: {
          state,
          zipcode
        }
      })

      return response
    } catch (error) {
      return []
    }
  }
}

export default SchoolService



// WEBPACK FOOTER //
// ./resources/js/services/SchoolService.js